import React from "react";
import { Tooltip, Typography } from "@mui/material";

interface IProps {
  text: string;
  maxLength: number;
  icon?: React.ReactNode;
  muiStyles: any;
}
const TruncatedText: React.FC<IProps> = (props) => {
  const { text, maxLength, icon, muiStyles } = props;

  const isTruncated = text.length > maxLength;
  const displayText = isTruncated ? text.slice(0, maxLength) + "..." : text;

  return (
    <Tooltip title={isTruncated ? text : ""} arrow>
      <Typography component={"p"} sx={muiStyles}>
        {icon} {displayText}
      </Typography>
    </Tooltip>
  );
};

export default TruncatedText;
